module.exports = __webpack_public_path__ + "media/images/icons/shield-05c39363c94f343c8baf220570cbdc93.svg";